import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Destination from "./Pages/Destination";
import Cities from "./Pages/Cities";
import CityDetails from "./Pages/CityDetails";
import DestinationDetail from "./Pages/DestinationDetail";
import WhyUs from "./Pages/WhyUs";
import FAQ from "./Pages/FAQ";
import Blog from "./Pages/Blog";
import Lead from "./Pages/Lead";
import TermsNCondiation from "./Pages/TermsNCondiation";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import Teams from "./Pages/Teams";
import { ToastContainer } from "react-toastify";
import BlogDetils from "./Pages/BlogDetils";
import { CountryProvider } from "./Components/CountryProvider";
import DestinationinCountryDetails from "./Pages/DestinationinCountryDetails";
import CountryList from "./Pages/CountryList";

function App() {
  return (
    <>
      <ToastContainer />
      <CountryProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/country" element={<CountryList />} />
            <Route path="/destination" element={<Destination />} />
            <Route path="/destination/:Country" element={<Cities />} />
            <Route path="/citydetail/:city" element={<CityDetails />} />
            <Route path="/destinationdetail/:city/:id" element={<DestinationDetail />} />
            <Route path="/DestinationinCountryDetails/:id" element={<DestinationinCountryDetails />} />
            <Route path="/whyus" element={<WhyUs />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/BlogDetils/:id" element={<BlogDetils />} />
            <Route path="/lead" element={<Lead />} />
            <Route path="/terms" element={<TermsNCondiation />} />
            <Route path="/policy" element={<PrivacyPolicy />} />
            <Route path="/teams" element={<Teams />} />
          </Routes>
        </Router>
      </CountryProvider>
    </>
  );
}

export default App;
